import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ServantsList from './ServantsList'
import ServantsTableList from './ServantsTableList'

const styles = {
  activePage: {
    color: '#FF4500',
  },
  page: {
    cursor: 'pointer',
  }
}

class ServantsPage extends React.Component {
  consts = {
    SERVANTS: 'SERVANTS',
    SERVANTS_TABLE: 'SERVANTS_TABLE',
  }

  state = {
    page: this.consts.SERVANTS,
  }

  change = (view) => () => {
    this.setState({
      page: view,
    })
  }

  render () {
    const { servants, ranks, servantRanks, avatars, paragons } = this.props
    const { page } = this.state
    return (<div
      id="srodek2"
    >
      <div id="tekst">
        <p className="summary">
          Lista Sług Azmodana liczy sobie
          <span className="glowing-text"> {servants && Object.keys(servants).length}</span> członków w tym:
        </p>
        <ul>
          { ranks && Object.keys(ranks).map(rankKey => (
            servantRanks && servantRanks[rankKey] &&
          <div key={rankKey}>
            <div>
              <li><span className="glowing-text">{Object.keys(servantRanks[rankKey]).length}</span> {ranks[rankKey].name}</li>
            </div>
          </div>
          ))}
        </ul>
        <img src="http://diablo.azmklan.org/grafika/aktywny.png" title="Aktywny Klanowicz" height="15" width="15" alt="activeMember"/> - Status Aktywnego, logował się w grze w ciągu ostatnich 200 dni.
        <br/>
        <img src="http://diablo.azmklan.org/grafika/nieaktywny.png" title="Nieaktywny Klanowicz" height="15" width="15" alt="noActiveMember" /> - Status Nieaktywnego, nie logował się w grze od ponad 200 dni.
        <br/><strong>Skład klanu AZM w serwisie:</strong> <a href="http://www.diablo3ladder.com/best-players/eu-paragon-0-2353_Sudzy_Azmodana.html" rel="noopener noreferrer" target="_blank">diablo3ladder.com</a>
        <br/>
        <strong>Widok: </strong>
          <span style={page === this.consts.SERVANTS ? styles.activePage : styles.page} onClick={this.change(this.consts.SERVANTS)}>KLASYCZNY</span>
          <span> | </span>
          <span style={page === this.consts.SERVANTS_TABLE ? styles.activePage : styles.page} onClick={this.change(this.consts.SERVANTS_TABLE)}>TABELA</span>
      {this.state.page === this.consts.SERVANTS ?
      <ServantsList
        servants={servants}
        avatars={avatars}
        ranks={ranks}
        servantRanks={servantRanks}
        paragons={paragons}
      /> : <ServantsTableList
        servants={servants}
        avatars={avatars}
        ranks={ranks}
        servantRanks={servantRanks}
        paragons={paragons}
        change={this.change}
      />
      }
      </div>
    </div>)
  }
}

ServantsPage.propTypes = {
  servants: PropTypes.object,
  servantRanks: PropTypes.object,
  ranks: PropTypes.object,
  paragons: PropTypes.object,
}
export default connect(state => state.servants)(ServantsPage)



// WEBPACK FOOTER //
// ./src/components/ServantsPage.js